import { Component, input, output, inject, LOCALE_ID } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SubProductTableItem } from '../../../../../../pages/admin-dashboard/products/add-sub-product/sub-products.model';

@Component({
  selector: 'app-sub-products-table',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  templateUrl: './sub-products-table.html',
})
export class SubProductsTable {
  private localeId = inject(LOCALE_ID);

  subProductsList = input.required<SubProductTableItem[]>();
  duplicateRowIndex = input<number | null>(null); 
  onRemove = output<number>(); 

  get isArabic(): boolean {
    return this.localeId.startsWith('ar');
  }
}